import React from 'react';
import { useRadioContext } from '../../context';
import { ReportEventFormFields } from './ReportEventFormFields';
import {
    CopyrightDisplay,
    DSADisplay,
    FeedbackDisplay,
    RefundDisplay,
} from './ReportMessages';

export const ReportEventFormDisplay = (props: {
    eventId: string;
    eventUrl: string;
    eventName: string;
    helpCenterLanguage: string;
    country: string;
    userCountry: string;
}) => {
    const {
        eventId,
        eventUrl,
        eventName,
        helpCenterLanguage,
        country,
        userCountry,
    } = props;
    const { selection } = useRadioContext();

    return (
        <>
            {selection === 'reason_refund' && (
                <RefundDisplay helpCenterLanguage={helpCenterLanguage} />
            )}
            {selection === 'reason_feedback' && (
                <FeedbackDisplay helpCenterLanguage={helpCenterLanguage} />
            )}
            {selection === 'reason_copyright_infringement' && (
                <CopyrightDisplay helpCenterLanguage={helpCenterLanguage} />
            )}
            {selection === 'reason_other_illegal_eu_dsa' && (
                <DSADisplay
                    eventId={eventId}
                    eventName={eventName}
                    eventUrl={eventUrl}
                />
            )}
            {selection !== 'reason_copyright_infringement' &&
                selection !== 'reason_refund' &&
                selection !== 'reason_feedback' &&
                selection !== 'reason_other_illegal_eu_dsa' && (
                    <ReportEventFormFields
                        eventId={eventId}
                        eventName={eventName}
                        eventUrl={eventUrl}
                        country={country}
                        userCountry={userCountry}
                    />
                )}
        </>
    );
};
